var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadGreyShape(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 20,
    viewBox: "0 0 32 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.08075 19.8745C1.74551 19.3529 0 17.2668 0 14.7727C0 11.9708 2.203 9.68376 4.97025 9.5515C4.69637 9.00229 4.5423 8.38279 4.5423 7.72727C4.5423 5.46793 6.37259 3.63636 8.63037 3.63636C9.42853 3.63636 10.1733 3.86526 10.8026 4.26103C11.6703 1.7797 14.0307 0 16.8065 0C20.3186 0 23.1657 2.8491 23.1657 6.36364C23.1657 6.5852 23.1544 6.80412 23.1323 7.01985C23.6516 6.88816 24.1954 6.81818 24.7555 6.81818C28.3931 6.81818 31.3419 9.76903 31.3419 13.4091C31.3419 17.0492 28.3931 20 24.7555 20C24.6752 20 24.5953 19.9986 24.5157 19.9957C24.4684 19.9985 24.4227 20 24.3788 20H4.54361C4.3746 20 4.21635 19.9543 4.08075 19.8745ZM17.7198 13.5736H20.8074L16.0834 6.82031L11.3594 13.5736H14.0859V19.9979H17.7198V13.5736Z",
    fill: "#AAAAAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadGreyShape);
export default __webpack_public_path__ + "static/media/upload-grey-shape.4295c37aa3d6ed7f9ad9a25f42c17b57.svg";
export { ForwardRef as ReactComponent };